/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateDocumentDto } from '../models/work-create-document-dto';
import { WorkDocument } from '../models/work-document';
import { WorkDocumentsGroupedByDocumenttypeDto } from '../models/work-documents-grouped-by-documenttype-dto';

@Injectable({ providedIn: 'root' })
export class WorkDocumentsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentsV1ControllerGetCustomerDocumentsForItem()` */
  static readonly DocumentsV1ControllerGetCustomerDocumentsForItemPath = '/v1/documents/item/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV1ControllerGetCustomerDocumentsForItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV1ControllerGetCustomerDocumentsForItem$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsService.DocumentsV1ControllerGetCustomerDocumentsForItemPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV1ControllerGetCustomerDocumentsForItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV1ControllerGetCustomerDocumentsForItem(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.documentsV1ControllerGetCustomerDocumentsForItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `documentsV1ControllerGetProductImagesForItem()` */
  static readonly DocumentsV1ControllerGetProductImagesForItemPath = '/v1/documents/item/{id}/productImages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV1ControllerGetProductImagesForItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV1ControllerGetProductImagesForItem$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsService.DocumentsV1ControllerGetProductImagesForItemPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV1ControllerGetProductImagesForItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV1ControllerGetProductImagesForItem(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.documentsV1ControllerGetProductImagesForItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `documentsV1ControllerGetDocumentsByDocumenttypeId()` */
  static readonly DocumentsV1ControllerGetDocumentsByDocumenttypeIdPath = '/v1/documents/byDocumenttypeId/{documenttypeId}';

  /**
   * Required permissions: users:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV1ControllerGetDocumentsByDocumenttypeId()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV1ControllerGetDocumentsByDocumenttypeId$Response(
    params: {
      documenttypeId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsService.DocumentsV1ControllerGetDocumentsByDocumenttypeIdPath, 'get');
    if (params) {
      rb.path('documenttypeId', params.documenttypeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * Required permissions: users:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV1ControllerGetDocumentsByDocumenttypeId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV1ControllerGetDocumentsByDocumenttypeId(
    params: {
      documenttypeId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.documentsV1ControllerGetDocumentsByDocumenttypeId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `documentsV1ControllerGetInternalDocumentsForEmployees()` */
  static readonly DocumentsV1ControllerGetInternalDocumentsForEmployeesPath = '/v1/documents/internalDocumentsForEmployees';

  /**
   * Required permissions: users:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV1ControllerGetInternalDocumentsForEmployees()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV1ControllerGetInternalDocumentsForEmployees$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocumentsGroupedByDocumenttypeDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsService.DocumentsV1ControllerGetInternalDocumentsForEmployeesPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocumentsGroupedByDocumenttypeDto>>;
      })
    );
  }

  /**
   * Required permissions: users:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV1ControllerGetInternalDocumentsForEmployees$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV1ControllerGetInternalDocumentsForEmployees(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDocumentsGroupedByDocumenttypeDto>> {
    return this.documentsV1ControllerGetInternalDocumentsForEmployees$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocumentsGroupedByDocumenttypeDto>>): Array<WorkDocumentsGroupedByDocumenttypeDto> => r.body)
    );
  }

  /** Path part for operation `documentsV1ControllerUploadFile()` */
  static readonly DocumentsV1ControllerUploadFilePath = '/v1/documents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV1ControllerUploadFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  documentsV1ControllerUploadFile$Response(
    params: {
      body: WorkCreateDocumentDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocument>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsService.DocumentsV1ControllerUploadFilePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocument>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV1ControllerUploadFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  documentsV1ControllerUploadFile(
    params: {
      body: WorkCreateDocumentDto
    },
    context?: HttpContext
  ): Observable<WorkDocument> {
    return this.documentsV1ControllerUploadFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocument>): WorkDocument => r.body)
    );
  }

  /** Path part for operation `documentsV1ControllerFixPhotosExifData()` */
  static readonly DocumentsV1ControllerFixPhotosExifDataPath = '/v1/documents/fixPhotosExifData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsV1ControllerFixPhotosExifData()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV1ControllerFixPhotosExifData$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDocumentsService.DocumentsV1ControllerFixPhotosExifDataPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsV1ControllerFixPhotosExifData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsV1ControllerFixPhotosExifData(
    params?: {
    },
    context?: HttpContext
  ): Observable<void> {
    return this.documentsV1ControllerFixPhotosExifData$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
